import { initializeFaro, getWebInstrumentations, LogLevel } from '@grafana/faro-web-sdk';
import { isProdURL } from './utils';

const NON_ERROR_CONSOLE_LEVELS = [LogLevel.TRACE, LogLevel.DEBUG, LogLevel.INFO, LogLevel.LOG, LogLevel.WARN];

let faroInstance = null;

function stripPageUrl (item) {
  const pageUrl = item?.meta?.page?.url;
  if (typeof pageUrl !== 'string') {
    return item;
  }
  return { ...item, meta: { ...item.meta, page: { ...item.meta.page, url: pageUrl.split(/[?#]/)[0] } } };
}

/** RUM only. Tracing is deferred until the customer-portal proxy allows W3C headers (see spec 5.4). */
export function initTelemetry () {
  if (faroInstance) {
    return faroInstance;
  }
  const url = process.env.REACT_APP_FARO_COLLECTOR_URL;
  if (!url) {
    return null;
  }
  try {
    faroInstance = initializeFaro({
      url,
      app: {
        name: 'customer-portal',
        version: process.env.REACT_APP_VERSION || 'dev',
        environment: isProdURL() ? 'prod' : 'dev'
      },
      sessionTracking: { enabled: true, samplingRate: 1, persistent: false },
      ignoreErrors: [/ResizeObserver loop/, /^Script error\.?$/, /^canceled$/i],
      ignoreUrls: [url],
      beforeSend: stripPageUrl,
      instrumentations: getWebInstrumentations({
        captureConsole: true,
        captureConsoleDisabledLevels: NON_ERROR_CONSOLE_LEVELS
      })
    });
  } catch (_error) {
    faroInstance = null;
  }
  return faroInstance;
}

export function __resetTelemetryForTests () {
  faroInstance = null;
}
